import React from 'react';

const ErrorPage = () => {
    return (
        <div>
            <h1>Error</h1>
            <p>An error occurred. Please try again later.</p>
            <button onClick={() => window.location.href = '/login'}>Login</button>
        </div>
    );
};

export default ErrorPage;
